import AllInfoContactsTab from "../../components/allInfoContactsTab";

const ListContacts = () => {
  return (
    <>
      <AllInfoContactsTab/>
    </>

  );
};

export default ListContacts;
